import { Audit } from "models/generateAuditSchemas";
import moment from "moment";
import { toDateString } from "utils/date-format";

export const toAuditDateString = (audit: Audit) => {
  audit.auditStartDateString = toDateString(audit.auditStartDate);
  audit.auditEndDateString = toDateString(audit.auditEndDate);
  audit.auditInitiationDateString = toDateString(audit.auditInitiationDate);
  audit.auditCloseDateString = toDateString(audit.auditCloseDate!);
  audit.statuteOfLimitationsString = toDateString(audit.statuteOfLimitations!);
  return audit;
};

export const extractYear = (date: number) => {
  return moment.utc(date * 1000).format("YYYY");
};

/**
 * Centralized error handling for audit operations
 * @param error - The error object from the API call
 * @param defaultMessage - The default message to show for non-duplicate errors
 * @returns The appropriate error message to display to the user
 */
export const getAuditErrorMessage = (
  error: any,
  defaultMessage: string,
): string => {
  const backendMessage = error?.data?.message || "";
  const isDuplicateError = backendMessage.includes("Duplicate audit found");

  return isDuplicateError ? "Error - duplicate audit exists." : defaultMessage;
};

/**
 * Helper function to find template value by label from team-specific templates
 * @param templateLabel - The template label to search for
 * @param teamTemplatesMap - Map of team names to their template options
 * @param teamName - The current team name
 * @returns The template value if found, undefined otherwise
 */
export const findTemplateValueByLabel = (
  templateLabel: string,
  teamTemplatesMap: Map<
    string,
    Array<{ label: string; value: string | undefined }>
  >,
  teamName: string,
): string | undefined => {
  return teamTemplatesMap
    .get(teamName)
    ?.find((template) => template.label === templateLabel)?.value;
};
